const createStorageSlice = (initial) => () => initial;
export {
  createStorageSlice
};
//# sourceMappingURL=storage.js.map
